export const defaultStyles = {
  color: "var(--theme-email-p1-color-text)",
  fontWeight: "var(--theme-email-p1-font-weight)",
  fontSize: "var(--theme-email-p1-font-size)",
  lineHeight: "var(--theme-email-p1-line-height)",
  letterSpacing: "var(--theme-email-p1-letter-spacing)",
  textAlign: "left",
  fontStyle: "normal",
  textDecoration: "none",
  textTransform: "none",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "12",
    paddingBottom: "12",
    paddingLeft: "24",
    paddingRight: "24",
  },
} as const;
